/**
 * Created by caiyuhao on 2017/1/31.
 */
// BASE
export const UPDATE_LOADING = 'UPDATE_LOADING'
export const UPDATE_DIRECTION = 'UPDATE_DIRECTION'
export const UPDATE_CHINA = 'UPDATE_CHINA'
export const UPDATE_SET = 'UPDATE_SET'

// TEST
export const GET_AD = 'GET_AD'
export const SET_AD = 'SET_AD'
export const SET_LIST = 'SET_LIST'
export const GET_LIST = 'GET_LIST'
export const GET_SHOP_LIST = 'GET_SHOP_LIST'
export const SET_SHOP_LIST = 'SET_SHOP_LIST'
export const SET_SHOP_FOOTER = 'SET_SHOP_FOOTER'
export const GET_SHOP_FOOTER = 'GET_SHOP_FOOTER'

// 购物环节
export const GET_STORE = 'GET_STORE'
export const SET_STORE = 'SET_STORE'



// WEBPACK FOOTER //
// ./src/vuex/mutations-type.js